export default __webpack_public_path__ + "static/media/icon_profile.e914199d.png";